import type { ProductDeleteConfirmationModalProps } from "@editor/components/AppModalTypes";

import React from "react";

import { useModal } from "@editor/hooks/useModal";
import { routes } from "@editor/utils/router";

import Button from "@replo/design-system/components/button/Button";
import { Modal } from "@replo/design-system/components/modal/Modal";
import { generatePath, useNavigate } from "react-router-dom";

import { useProductDelete } from "../hooks/useProductDelete";

export function ProductDeleteConfirmationModal({
  productId,
  projectId,
}: ProductDeleteConfirmationModalProps) {
  const { deleteProduct, isLoading } = useProductDelete();
  const { closeModal } = useModal();
  const navigate = useNavigate();

  const handleDelete = async () => {
    await deleteProduct(productId);
    closeModal({ type: "productDeleteConfirmationModal" });
    navigate(
      generatePath(routes.shops.products.list, {
        projectId,
      }),
    );
  };

  return (
    <Modal
      size="sm"
      isOpen={true}
      onOpenChange={(open) => {
        if (!open) {
          closeModal({ type: "productDeleteConfirmationModal" });
        }
      }}
      title="Delete Product"
      description="You will not be able to undo this action. All pages with this product will not be connected to product."
      footer={
        <Button
          variant="danger"
          size="base"
          onClick={() => void handleDelete()}
          isLoading={isLoading}
        >
          Delete Permanently
        </Button>
      }
    />
  );
}
